import axios from 'axios';
import store from '@/store';

const apiPath = `${store.state.apiPathWithVersion}/teletag`;

export default {
  async list(params) {
    let apiUrl = store.state.countrySelected.api;
    params.lang = store.state.langSelected.langWsp;
    try {
      let resp = await axios.get(`${apiUrl}/${apiPath}/list`, {
        params: params
      });
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  },

  async disable(params) {
    let apiUrl = store.state.countrySelected.api;
    params.lang = store.state.langSelected.langWsp;
    try {
      let resp = await axios.post(`${apiUrl}/${apiPath}/disable?lang=${params.lang}`, params);
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  },

  async changePlate(params) {
    let apiUrl = store.state.countrySelected.api;
    params.lang = store.state.langSelected.langWsp;
    try {
      let resp = await axios.post(`${apiUrl}/${apiPath}/changePlate?lang=${params.lang}`, params);
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  },

  async activate(params) {
    let apiUrl = store.state.countrySelected.api;
    params.lang = store.state.langSelected.langWsp;
    try {
      let resp = await axios.post(`${apiUrl}/${apiPath}/activate?lang=${params.lang}`, params);
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  }
};
